import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

require("./assets/css/style.css");

Vue.config.productionTip = false

export const Bus = new Vue();

if (!globalThis.structuredClone) {
  globalThis.structuredClone = function structuredClone(object) {
    return JSON.parse(JSON.stringify(object));
  }
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
